/** Mirrors the client sidebar's product groups (app/configs/sidebar.ts). */
export enum CompanyFeature {
  BrandIntelligence = 'brand_intelligence',
  ShoppingIntelligence = 'shopping_intelligence',
  CompetitiveIntelligence = 'competitive_intelligence',
  BrandProtection = 'brand_protection',
  BrandCompliance = 'brand_compliance',
  StopGo = 'stop_go',
}

export interface AccountManagerPeriodDTO {
  ID: string
  start: string
  end: string | null
  accountManagerID: string
}

interface CreateAccountManagerPeriodDTO {
  start: string
  end?: string | null
  accountManagerID: string
}

interface UpdateAccountManagerPeriodDTO {
  ID: string
  start: string
  end?: string | null
  accountManagerID: string
}

interface DeleteAccountManagerPeriodDTO {
  ID: string
}

export interface BatchAccountManagerPeriodDTO {
  create: CreateAccountManagerPeriodDTO[]
  update: UpdateAccountManagerPeriodDTO[]
  delete: DeleteAccountManagerPeriodDTO[]
}

export interface FeaturePeriodDTO {
  ID: string
  feature: CompanyFeature
  start: string
  end: string | null
  isTest: boolean
}

interface CreateFeaturePeriodDTO {
  start: string
  end?: string | null
  feature: CompanyFeature
  isTest?: boolean
}

interface UpdateFeaturePeriodDTO {
  ID: string
  start: string
  end?: string | null
  feature: CompanyFeature
  isTest: boolean
}

interface DeleteFeaturePeriodDTO {
  ID: string
}

export interface BatchFeaturePeriodDTO {
  create: CreateFeaturePeriodDTO[]
  update: UpdateFeaturePeriodDTO[]
  delete: DeleteFeaturePeriodDTO[]
}

export interface CompanyFeatureDTO {
  feature: CompanyFeature
  status: 'active' | 'scheduled' | 'expired' | 'none'
  isTest: boolean
  start: string | null
  end: string | null
}

export type ModuleState = 'active' | 'scheduled' | 'expired' | 'inactive' | 'soon'

export const resolveModuleState = (
  dto: CompanyFeatureDTO | undefined,
  isBuilt: boolean,
): ModuleState => {
  if (!isBuilt) return 'soon'
  if (dto?.status === 'active') return 'active'
  if (dto?.status === 'scheduled') return 'scheduled'
  if (dto?.status === 'expired') return 'expired'
  return 'inactive'
}
